import React from "react"

interface VerticalDividerProps extends React.HTMLProps<HTMLDivElement> {
  backgroundColor: string
  height: string
}

export const VerticalDivider = ({
  backgroundColor,
  height,
  style,
  ...rest
}: VerticalDividerProps) => {
  return (
    <div
      style={{
        width: "1px",
        height: height,
        background: backgroundColor,
        borderRadius: "100px",
        ...style,
      }}
      {...rest}
    ></div>
  )
}
